"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIRSCountry = void 0;
const country_1 = require("../enums/country");
const getIRSCountry = () => {
    return country_1.OrganizationCountry.UnitedStates;
};
exports.getIRSCountry = getIRSCountry;
